import { Card } from "react-bootstrap";

export interface KpiMetricRow {
  icon: string;
  label: string;
  value: string | number;
  variant?: "success" | "warning" | "danger" | "info" | "primary";
}

interface KpiCardProps {
  rows: [KpiMetricRow, KpiMetricRow];
}

const softBg: Record<NonNullable<KpiMetricRow["variant"]>, string> = {
  success: "#ECFDF3",
  warning: "#FFFBEB",
  danger: "#FEF2F2",
  info: "#F0F9FF",
  primary: "#EEF2FF",
};

const ICON_SIZE = 28;

const KpiMetricRowItem = ({
  row,
  showDivider,
}: {
  row: KpiMetricRow;
  showDivider: boolean;
}) => {
  const variant = row.variant ?? "info";

  return (
    <div
      className={`d-flex align-items-center justify-content-between gap-2${
        showDivider ? " border-top border-light-subtle pt-2" : ""
      }`}
    >
      <div className="d-flex align-items-center gap-2 min-w-0">
        <div
          className={`d-flex align-items-center justify-content-center rounded-2 text-${variant} flex-shrink-0`}
          style={{
            height: ICON_SIZE,
            width: ICON_SIZE,
            backgroundColor: softBg[variant],
          }}
        >
          <i className={`${row.icon}`} style={{ fontSize: "1rem" }} />
        </div>
        <span className="small fw-semibold text-truncate mb-0">{row.label}</span>
      </div>
      <span className={`fs-6 fw-bold mb-0 flex-shrink-0 text-${variant}`}>
        {row.value}
      </span>
    </div>
  );
};

export const KpiCard = ({ rows }: KpiCardProps) => {
  return (
    <Card className="h-100 shadow-sm border-0 rounded-4">
      <Card.Body className="d-flex flex-column justify-content-center gap-2 p-2">
        <KpiMetricRowItem row={rows[0]} showDivider={false} />
        <KpiMetricRowItem row={rows[1]} showDivider={true} />
      </Card.Body>
    </Card>
  );
};
